import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ImageModalComponent({
  show,
  imageUrl,
  altText,
  onClose,
}) {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.9)", zIndex: 1060 }}
      onClick={onClose}
    >
      <button
        className="btn btn-light position-absolute top-0 end-0 m-3"
        style={{ zIndex: 1061 }}
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faTimes} size="lg" />
      </button>

      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content bg-transparent border-0">
          <div className="modal-body p-0 text-center">
            <img
              src={imageUrl}
              alt={altText || "Image"}
              className="img-fluid rounded"
              style={{ maxHeight: "90vh", objectFit: "contain" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
